<template>
  <div>
    <MapModal
      :modalNode="modalNode"
      title="PTV交通模拟"
      id="scenerModel"
      :close="close"
      ref="scenerModel"
    >
      <template slot="head">
        <span class="uploadStyle">
          <el-button type="primary" style="margin-left: 8px">
            <el-upload
              action=""
              res="upload"
              :http-request="httpRequest"
              :before-upload="beforeUpload"
              multiple
              :show-file-list="false"
            >
              <span style="color: aliceblue">选择文件</span>
            </el-upload>
          </el-button>
        </span>
      </template>
    </MapModal>
  </div>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");

//按需加载
import {
  setPtvaddUpload,
  BimTrafficSimulationNodeList,
  BimTrafficSimulationNodeDelete,
} from "@/api/api";
import * as mapWork from "./trafficSimulation.js";
import * as PTV_trafficFlow from "./PTV_trafficFlow.js";
import axios from "axios";

export default {
  name: "traffic-simulation",
  components: { MapModal },
  props: ["close"],
  data() {
    return {
      show: false,
      checkedData: [],
      data: [],
      defaultProps: {
        children: "children",
        label: "title",
      },
      statusPlay: "suspend",
      modalNode: {
        fixedRoute: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 55,
            y: -350,
            // unit: "px", // 默认px
          },
          width: "260px", // 宽度配置 默认450px
          height: `${
            document.querySelector("#mars3d-container").offsetHeight - 80
          }px`, // 配置模态框中心高度
          // height: "350px",
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: false,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "tree", // 模态框内容类型 关键
            id: "modalTree", // id和ref使用的同一个
            name: "name", // 树的展示字段 默认name
            expand: false,
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [],
            expandClick: true,
            i_icon: {
              level_1: "fa fa-car",
              level_2: "las la-map-marker",
            },
            search: {
              keywords: "name", // 搜素配置关键字 默认是name
            },
            checkBox: false,
            checkeArr: [],
            check: this.checkBoxClick,
            nodeClick: this.nodeClick,
          },
        },
      },
      ifAddModal: false,
      ifAddSpot: false,
      ifEditSpot: false,
      currentState: "add",
      editSpotId: "",
      addSpotId: "",
      projectId: window.sessionStorage.getItem("nowProjectId"),
    };
  },
  computed() {},
  filters: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  methods: {
    // 获取树形数据
    getTreeNodeList() {
      let modelData = {
        ProjectId: window.sessionStorage.getItem("nowProjectId"),
        dataType: 2,
      };
      BimTrafficSimulationNodeList(modelData)
        .then((res) => {
          if (res.data.code == 200 || res.data.code == 204) {
            mapWork.getRequestData(res.data.data);
            res.data.data.forEach((item) => {
              item.operate = [
                {
                  i_icon: "small-operation-btn el-icon-video-play",
                  click: (e) => this.play(e),
                },
                {
                  i_icon: "small-operation-btn el-icon-delete",
                  click: (e) => this.delete(e),
                },
              ];
            });
            this.modalNode.fixedRoute.content.treeDataJson = res.data.data;
          } else {
            this.$message({
              message: "请求失败，请稍后再试",
              type: "error",
              offset: 100,
              showClose: true,
              duration: 1600,
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: "请求失败，请稍后再试",
            type: "error",
            offset: 100,
            showClose: true,
            duration: 1600,
          });
        });
    },
    addFunction() {
      this.modalNode.fixedRoute.content.treeDataJson.forEach((item) => {
        item.operate[0].i_icon = "small-operation-btn el-icon-video-play";
      });
    },
    play(e) {
      if (e.operate[0].i_icon == "small-operation-btn el-icon-video-play") {
        //播放
        this.addFunction();
        setTimeout(() => {
          e.operate[0].i_icon = "small-operation-btn el-icon-switch-button";
          PTV_trafficFlow.showCar(e.czmlUrl);
        }, 50);
      } else {
        //停止
        e.operate[0].i_icon = "small-operation-btn el-icon-video-play";
        PTV_trafficFlow.removeLayer();
        this.$forceUpdate();
      }
    },
    // 点击上传
    httpRequest(item) {
      // this.ruleForm.file = item.file.name;
      // debugger
      console.log(item);
      // this.modalNode.ModelNase.loading = true;
      // item.file.remarks = "";

      let formData = new FormData();

      formData.append("ProjectId", this.projectId); //项目ID
      formData.append(
        "name",
        item.file.name.substring(0, item.file.name.lastIndexOf("."))
      );
      formData.append("DataType", 2);
      formData.append("Files", item.file);

      axios
        .post("/baseIP/BimTrafficSimulationNode/addUpload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + window.sessionStorage.getItem("token"),
            "X-Authorization":
              "Bearer " + window.sessionStorage.getItem("refreshToken"),
          },
        })
        .then((res) => {
          console.log(res, "res");
          if (res.data.code == 200) {
            this.getTreeNodeList();
            this.$notify({
              title: "上传成功",
              message: "",
              type: "success",
              duration: 1000,
              offset: 320,
            });
          } else {
            this.$notify({
              title: "失败",
              message: res.data.message,
              type: "error",
              duration: 2000,
              offset: 320,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            title: "失败",
            message: error.message,
            type: "error",
            duration: 1000,
            offset: 320,
          });
        });
    },
    // 上传之前对文件作限制
    beforeUpload(file) {},
    checkBoxClick(e) {
      console.log(e, "111111");
    },
    nodeClick(e) {
      if (PTV_trafficFlow.graphicLayer) PTV_trafficFlow.graphicLayer.flyTo();
      // console.log(, "111111");
    },
    delete(e) {
      BimTrafficSimulationNodeDelete({
        id: e.id,
      })
        .then((res) => {
          let { code } = res.data;
          if (code == 200 || code == 204) {
            this.getTreeNodeList();
            this.$notify({
              title: "删除成功",
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
          } else {
            this.$notify({
              title: "删除失败",
              message: "",
              type: "error",
              duration: 960,
              offset: 320,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            title: "删除失败",
            message: "",
            type: "error",
            duration: 960,
            offset: 320,
          });
        });
    },
  },
  mounted() {
    this.getTreeNodeList();
  },
  destroyed() {
    mapWork.init();
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.content {
  padding: 15px 15px 0 15px;
}
/deep/.el-form.settings
  .el-form-item
  .el-form-item__content
  .el-input[data-v-2e44ca1c] {
  width: 250px !important;
}
/deep/.el-input {
  width: 250px;
}
.submitBtn {
  display: flex;
  flex-direction: inherit !important;
}
.btns {
  margin-bottom: 12px;
  .el-form-item__content {
    width: 166px;
    @include button_primary();
    @include button_default();
  }
}
.uploadStyle {
  display: flex;
}
/deep/.el-button {
  padding: 12px 15px;
  font-size: 12px;
}
/deep/.el-form-item__label {
  color: #606266 !important;
}

/deep/.el-radio__label {
  color: #606266 !important;
}
/deep/.el-radio.is-checked .el-radio__label {
  color: #606266 !important;
}
/deep/.el-radio .el-radio__input.is-checked + .el-radio__label {
  color: #409eff !important;
}
/deep/.el-radio__input.is-checked .el-radio__inner:after {
  transform: translate(-50%, -50%) scale(1);
}
/deep/.el-radio__inner:after {
  width: 4px;
  height: 4px;
  border-radius: 100%;
  background-color: #fff;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.15s ease-in;
}
</style>
